/* TAG Collectibles 2026 — homepage v2 interactions */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Showroom ---------- */
  $$('[data-show]').forEach((show) => {
    const slides = $$('[data-show-slide]', show);
    const tabs = $$('[data-show-tab]', show);
    const cur = $('[data-show-current]', show);
    const secs = parseInt(show.dataset.autoplay || '0', 10);
    show.style.setProperty('--n', slides.length);
    show.style.setProperty('--dur', secs + 's');
    let i = 0, timer = null, paused = false;

    const go = (n, user) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
      tabs.forEach((t, k) => {
        t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i));
        const bar = t.querySelector('.show__bar i'); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      if (cur) cur.textContent = String(i + 1).padStart(2, '0');
      if (user) restart();
    };
    const restart = () => {
      clearTimeout(timer);
      if (!secs || reduce || slides.length < 2) { show.classList.remove('is-playing'); return; }
      show.classList.add('is-playing');
      if (!paused) timer = setTimeout(() => { go(i + 1); restart(); }, secs * 1000);
    };
    const pause = (p) => {
      paused = p; show.classList.toggle('is-paused', p);
      if (p) clearTimeout(timer); else restart();
    };
    tabs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.showTab, 10), true)));
    show.addEventListener('mouseenter', () => pause(true));
    show.addEventListener('mouseleave', () => pause(false));
    show.addEventListener('focusin', () => pause(true));
    show.addEventListener('focusout', (e) => { if (!show.contains(e.relatedTarget)) pause(false); });
    show.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') go(i + 1, true);
      if (e.key === 'ArrowLeft') go(i - 1, true);
    });
    // swipe on touch
    let sx = null;
    show.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', (e) => {
      if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1), true);
    });
    // pause when off-screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { if (!show.matches(':hover')) pause(!en.isIntersecting); }, { threshold: .25 }).observe(show);
    }

    // tilt + sheen follow the pointer
    if (fine && !reduce) {
      const stage = $('.show__stage', show);
      let raf = null;
      stage.addEventListener('pointermove', (e) => {
        const r = stage.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const inner = $('.show__slide.is-active .show__slab-inner', show); if (!inner) return;
          inner.style.setProperty('--ry', (x * 22).toFixed(2) + 'deg');
          inner.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg');
          const sheen = inner.querySelector('.show__sheen');
          if (sheen) { sheen.style.setProperty('--sx', (50 + x * 120).toFixed(1) + '%'); sheen.style.setProperty('--sy', (50 + y * 80).toFixed(1) + '%'); }
          show.classList.add('is-tilting');
        });
      });
      stage.addEventListener('pointerleave', () => {
        $$('.show__slab-inner', show).forEach((el) => { el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg'); });
        show.classList.remove('is-tilting');
      });
    }
    go(0); restart();
  });

  /* ---------- Drop index ---------- */
  $$('[data-dx]').forEach((dx) => {
    const rows = $$('[data-dx-row]', dx);
    $$('[data-dx-filter]', dx).forEach((btn) => btn.addEventListener('click', () => {
      const f = btn.dataset.dxFilter;
      $$('[data-dx-filter]', dx).forEach((b) => { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', String(b === btn)); });
      rows.forEach((r) => { r.parentElement.hidden = !(f === 'all' || r.dataset.status === f); });
    }));
    const float = $('[data-dx-float]', dx);
    if (!float || !fine) return;
    const img = float.querySelector('img');
    rows.forEach((r) => {
      r.addEventListener('mouseenter', () => { if (r.dataset.img) { img.src = r.dataset.img; float.classList.add('is-on'); } });
      r.addEventListener('mouseleave', () => float.classList.remove('is-on'));
      r.addEventListener('mousemove', (e) => {
        const w = float.offsetWidth, h = float.offsetHeight;
        let x = e.clientX + 28, y = e.clientY - h / 2;
        if (x + w > window.innerWidth - 16) x = e.clientX - w - 28;
        y = Math.max(16, Math.min(window.innerHeight - h - 16, y));
        float.style.setProperty('--fx', x + 'px'); float.style.setProperty('--fy', y + 'px');
      });
    });
  });

  /* ---------- TAG Experience story ---------- */
  $$('[data-scan]').forEach((scan) => {
    const visual = $('[data-scan-visual]', scan);
    const steps = $$('[data-scan-step]', scan);
    const tabs = $$('[data-tab]', scan);
    const panes = $$('[data-pane]', scan);
    const set = (n) => {
      visual.dataset.step = n;
      steps.forEach((s, k) => s.classList.toggle('is-active', k === n));
      tabs.forEach((t) => t.classList.toggle('is-on', parseInt(t.dataset.tab, 10) === n));
      panes.forEach((p) => {
        const on = parseInt(p.dataset.pane, 10) === n;
        p.classList.toggle('is-on', on);
        const v = p.querySelector('video');
        if (v) {
          if (on) { if (!v.src && v.dataset.src) v.src = v.dataset.src; v.play && v.play().catch(() => {}); }
          else if (v.pause) v.pause();
        }
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((ens) => {
        ens.forEach((en) => { if (en.isIntersecting) set(parseInt(en.target.dataset.scanStep, 10)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach((s) => io.observe(s));
    }
    set(0);
  });

  /* ---------- Collaborations reel ---------- */
  $$('[data-reel]').forEach((reel) => {
    const track = $('[data-reel-track]', reel);
    const bar = $('[data-reel-bar]', reel);
    const card = () => track.querySelector('.reel__card');
    const step = () => (card() ? card().getBoundingClientRect().width + 16 : 320);
    const p = $('[data-reel-prev]', reel), n = $('[data-reel-next]', reel);
    p && p.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    n && n.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    const upd = () => {
      if (!bar) return;
      const max = track.scrollWidth - track.clientWidth;
      const vis = track.clientWidth / track.scrollWidth;
      bar.style.width = (vis * 100).toFixed(1) + '%';
      bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0).toFixed(1) + '%)';
    };
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
    // drag to scroll (mouse)
    let down = false, startX = 0, startL = 0, moved = false;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startL = track.scrollLeft; });
    window.addEventListener('pointermove', (e) => {
      if (!down) return; const dx = e.clientX - startX;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
      track.scrollLeft = startL - dx;
    });
    window.addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => track.classList.remove('is-dragging'), 0); });
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
  });
})();
